import createCachedSelector from 're-reselect';

const emptyArray = [];
const defaultVerification = {
  isLoaded: false,
  summaryLoaded: false
};

export const getOfferVerifications = (state, partnerId) => {
  const partnerVerificationData = state.entities.offerPartnerVerifications[partnerId];
  return partnerVerificationData ? partnerVerificationData.verifications : emptyArray;
};
const getVerificationData = (state, partnerId) =>
  state.currentOffer.clientVerificationsData.verifications[partnerId] || defaultVerification;

export const getVerificationIsLoaded = createCachedSelector(getVerificationData, verifications => {
  return verifications.isLoaded;
})((_, partnerId) => partnerId);

export const getVerificationSummaryIsLoaded = createCachedSelector(getVerificationData, verifications => {
  return verifications.summaryLoaded;
})((_, partnerId) => partnerId);

export const getOfferPartnerVerificationsSummary = createCachedSelector(getVerificationData, verifications => {
  return verifications.summary || null;
})((_, partnerId) => partnerId);

export const getOfferPartnerVerifications = createCachedSelector(
  getVerificationIsLoaded,
  getOfferVerifications,
  (isLoaded, verifications) => {
    if (!isLoaded) {
      return emptyArray;
    }
    return verifications;
  }
)((_, partnerId) => partnerId);

export const getVerificationTypesLoaded = state => {
  return state.dictionaries.verificationTypes && state.dictionaries.verificationTypes.isLoaded;
};

export const getVerificationTypes = state => {
  if (state.dictionaries.verificationTypes && state.dictionaries.verificationTypes.isLoaded) {
    const verificationTypes = JSON.parse(JSON.stringify(state.dictionaries.verificationTypes));
    delete verificationTypes.isLoaded;
    delete verificationTypes.loading;

    return Object.keys(verificationTypes).map(i => verificationTypes[i]);
  }

  return [];
};
